import { Component, inject, signal, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HorusBtnDirective } from '../../directives/horus-btn.directive';
import { VersionBannerState } from '../../services/version-banner.state';

@Component({
  selector: 'app-version-banner',
  standalone: true,
  imports: [CommonModule, HorusBtnDirective],
  templateUrl: './version-banner.component.html',
  styleUrls: ['./version-banner.component.scss'],
})
export class VersionBannerComponent {
  readonly state = inject(VersionBannerState);
  readonly isDismissed = signal(false);

  onReload(): void {
    this.state.updateLocalVersion();
    window.location.reload();
  }

  onDismiss(): void {
    this.isDismissed.set(true);
  }

  readonly showBanner = computed(() => {
    return this.state.shouldShowBanner() && !this.isDismissed();
  });
}
